import { render, staticRenderFns } from "./PageBackBtn.vue?vue&type=template&id=3e088166&scoped=true"
import script from "./PageBackBtn.vue?vue&type=script&lang=js"
export * from "./PageBackBtn.vue?vue&type=script&lang=js"
import style0 from "./PageBackBtn.vue?vue&type=style&index=0&id=3e088166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e088166",
  null
  
)

export default component.exports